import { render, staticRenderFns } from "./PtspTerminalConfig.vue?vue&type=template&id=4dceff2b&scoped=true"
import script from "./PtspTerminalConfig.vue?vue&type=script&lang=js"
export * from "./PtspTerminalConfig.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./PtspTerminalConfig.vue?vue&type=style&index=1&id=4dceff2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dceff2b",
  null
  
)

export default component.exports